import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem, Col, Row, Card, CardBody, Label } from 'reactstrap';
import BASE_URL, { fetchDataApi, fetchdataFromHrms, registerEmployee, verifyOtpApi } from '../Services/Employees';
import { Link, useBeforeUnload, useNavigate } from 'react-router-dom';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { MDBInput, MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
import 'react-toastify/dist/ReactToastify.css';
import './Registration.css';
import registerPath from "./../../assets/draw2.webp";
import Header from './../Header/Header';


const Registration = (props) => {

  useBeforeUnload(() => {
    if (window) localStorage.clear();
      });
  
 
  const [hrmsId, setHrmsId] = useState('');
  const [response, setApiResponse] = useState('');
  const [otp, setOtp] = useState('');
  const [otpDiv, setOtpDiv] = useState(false);
  const [registerDiv, setRegisterDiv] = useState(false);
  const [successMessage, setMessage] = useState('');
  const [hrms, setHrms] = useState(true);
  const [modal, setModal] = useState(false);
  const [GenerateOTp, setGenerateOTP] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [ForRegsitration, setForRegsitration] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [timer, setTimer] = useState(120); 
   const [img, setImg] = useState();
   const [check, setCheck] = useState(false);
   const [isDisabled, setIsDisabled] = useState(true);
  // Set timer to 120 seconds (2 minutes)

  useEffect(() => {
    if (successMessage !== '') {
      withReactContent(Swal).fire({
        text: successMessage,
        allowOutsideClick:false
      });
    }
    setMessage("");
  }, [successMessage]);

  useEffect(() => {
    let interval;
    if (isResendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsResendDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isResendDisabled, timer]);

  const toggle = () => setModal(!modal);
  const imageUrl =BASE_URL+"/fetchImage?hrmsId="+hrmsId;
  const [errors, setError] = useState({
    hrmsId: '',
    otp: ''
  });

  const fetchImage = async () => {
    const res = await fetch(imageUrl);
  const imageBlob = await res.blob();
  console.log(res)
  console.log(imageBlob)
  const imageObjectURL = URL.createObjectURL(imageBlob);
  setImg(imageObjectURL);
    };
  function validateOtp() {
    let valid = true;
    const errorscopy = { ...errors };
    if (otp.trim()) {
      errorscopy.otp = "";
    } else {
      errorscopy.otp = "\"OTP cannot be Blank\"";
      valid = false;
    }
    setError(errorscopy);
    return valid;
  }

  const navigate = useNavigate();

  function validateform() {
    let valid = true;
    const errorscopy = { ...errors };
    if (hrmsId.trim()) {
      errorscopy.hrmsId = "";
    } else {
      errorscopy.hrmsId = "\"HRMS ID cannot be Blank\"";
      valid = false;
    }
    setError(errorscopy);
    return valid;
  }

  function fetchDataFromHrms() {
    if (validateform()) {
      const data = { hrmsId };
      fetchDataApi(data).then((response) => {
        
        if(!response.data.responseDto.register){
          setApiResponse(response.data.employeeDto);
          setImg('data:image/jpeg;base64,' + response.data.employeeDto.byteimg);
          setForRegsitration(true)
        }
        setOtpDiv(true);
        setHrms(false);
        setGenerateOTP(false);
        setDisabled(true);
       // props.handleCallback(response.data.responseDto.message);
        setMessage(response.data.responseDto.message);
      },
        (error) => {
          props.handleCallback(error.response.data);
          setMessage(error.response.data);
        });
    }
  }

  function openModal(){
    if(ForRegsitration){
      setModal(!modal) 
    }
  }

  function verifyEnteredOTP() {
    const data = { hrmsId, otp};
    if (validateOtp()) {
      verifyOtpApi(data).then((response) => {
        localStorage.setItem("tokenId", response.data.token);
        setOtpDiv(!otpDiv);
        setHrms(!hrms);
        openModal();
        if(!ForRegsitration){
          setMessage('Login Successfull');
          setTimeout(() => {
            navigate('/dashboard/employeeDashboard');
          }, 1000);
        }
        
        },
        (error) => {
          setMessage(error.response.data.message);
        });
    }
  }

  function resendOTP() {
    if (validateform()) {
      const data = { hrmsId };
      fetchDataApi(data).then((response) => {
        if(!response.data.responseDto.register){
          setImg('data:image/jpeg;base64,' + response.data.employeeDto.byteimg);
          setApiResponse(response.data.employeeDto);
          setForRegsitration(true)
        }
        setMessage(response.data.responseDto.message);
        setOtpDiv(true);
        setHrms(false);
        setIsResendDisabled(true);
        setTimer(120); // reset timer to 120 seconds (2 minutes)
      },
        (error) => {
          setMessage(error.response.data);
        });
    }
  }

  function Cancel() {
    window.location.reload(false);
  }

  function confirmDetails() {
    toggle();
    register();
  }

  const onCheckboxClick = () => {
     setCheck(!check);
     check ? setIsDisabled(true) : setIsDisabled(false);
  };

  function register() {
    const data = 
    { hrmsId
    };
    registerEmployee(data).then((response) => {
      localStorage.setItem("tokenId", response.data.token);
      setMessage(response.data.message);
      setGenerateOTP(true);
      setHrmsId('');
      setTimeout(() => {
        navigate('/dashboard/employeeDashboard');
      }, 1000);
    });
  }

  function displayOtpBlock() {
    if (otpDiv) {
      return <>
        <div style={{ fontWeight: 'bold', color: 'grey', paddingTop: '4%',fontSize:"14px" }}>Enter OTP</div>
        <MDBInput wrapperClass={`mb-1 ${errors.otp ? 'is-invalid' : ''}`} id="otpId" placeholder='Enter OTP' type='text' maxLength="6" onChange={event => setOtp(event.target.value)} />
        {errors.otp && <div className='invalid-feedback' style={{ fontSize: "14px" }}>{errors.otp}</div>}
        <div className='d-flex justify-content-around mt-3'>
          <button className='btn bg-success px-3 py-2 mx-2' style={{ color: "white" }} onClick={verifyEnteredOTP}>Verify OTP</button>
          <button className='btn bg-danger px-3 py-2 mx-2' style={{ color: "white" }} onClick={resendOTP} disabled={isResendDisabled}>
            {isResendDisabled ? `Resend OTP (${Math.floor(timer / 60)}:${String(timer % 60).padStart(2, '0')})` : 'Resend OTP'}
          </button>
        </div>
      </>
    }
  }

  function showHrmsBlock() {
    if (hrms) {
      return <>
     
        <div style={{ fontWeight: 'bold', color: 'grey', paddingTop: '4%',fontSize:"14px",marginBottom:"1%" }}> Enter HRMS ID</div>
        <MDBInput wrapperClass={`mb-1 ${errors.hrmsId ? 'is-invalid' : ''}`} id="hrmsId" type='text' placeholder='Type HRMS ID' value={hrmsId} disabled={disabled} onChange={event => setHrmsId(event.target.value)} />
        {errors.hrmsId && <div className='invalid-feedback' style={{ fontSize: "14px" }}>{errors.hrmsId}</div>}
      </>
    }
  }

  function ShowGenerateOTp() {
    if (GenerateOTp) {
      return <>
        <div className='text-center mt-3' style={{textAlign:'center'}}>
          <button className='btn bg-primary px-3 py-2' style={{ color: "white" }} onClick={fetchDataFromHrms}>Generate OTP</button>
        </div>
      </>
    }
  }

  function displayRegisterBlock() {
    if (registerDiv) {
      return <>
        <div className='text-center text-md-start mt-0 pt-0 mt-3'>
          <button className='btn bg-success px-3 py-2' style={{ color: "white" }} onClick={register}>Register</button>
        </div>
      </>
    }
  }

  return (
<>
    <Header/>
    <div style={{backgroundColor:"#f5f5f5"}}>
    <div style={{height:"70vh"}}>
      <Row className='d-flex justify-content-center py-5' >
        {/* <MDBCol col='10' md='6'>
          <img src={registerPath} width={"100%"} alt="Registration" />
        </MDBCol> */}
        <Col col='4' md='4' className='py-4 mt-4' style={{ boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", padding: "2%", borderRadius: "8px", backgroundColor: "white" }}>
          <div className="d-flex flex-row align-items-center justify-content-center">
            <h3 className="mb-0 me-3">Register/Login</h3><br/>
            <p className="text-center fw-bold mx-3 mb-0"></p>
          </div>
          {showHrmsBlock()}
          {ShowGenerateOTp()}
          {displayOtpBlock()}
          {displayRegisterBlock()}
          <div className='text-center text-md-start mt-0 pt-0 mt-3'>
            <Modal isOpen={modal}  backdrop="static">
              <ModalHeader toggle={toggle}>Verify Your Details</ModalHeader>
              <ModalBody>
                <Card style={{ width: '28rem' }}>
                  <CardBody />
                  <Row>
                    <Col md={8}>
                      <ListGroup flush>
                        <ListGroupItem>
                          <h6>Name: <span style={{ marginLeft: "3px", fontWeight: "700" }}>{response.employeeName}</span></h6>
                        </ListGroupItem>
                        <ListGroupItem>
                          <h6>Mobile Number: <span style={{ marginLeft: "3px", fontWeight: "700" }}>{response.mobileNumber}</span></h6>
                        </ListGroupItem>
                        <ListGroupItem>
                          <h6>Father's Name: <span style={{ marginLeft: "3px", fontWeight: "700" }}>{response.fatherName}</span></h6>
                        </ListGroupItem>
                        <ListGroupItem>
                          <h6>Designation:<span style={{ marginLeft: "3px", fontWeight: "700" }}>{response.designation}</span></h6>
                        </ListGroupItem>
                        <ListGroupItem>
                          <h6>Present Place of Posting: <span style={{ marginLeft: "3px", fontWeight: "700" }}>{response.station}</span></h6>
                        </ListGroupItem>
                      </ListGroup>
                    </Col>
                    <Col md={4}>
                      <img className='mt-5'  alt="Card" src={img} width="130"></img>
                    </Col>
                  </Row>
                  <CardBody />
                </Card>
                <div className='d-flex align-items-start'>
                <input type='checkbox' id='check' style={{width:"12px", marginTop:"2%"}}  onClick={onCheckboxClick}></input>

                <Label for='chechk'>&nbsp;I confirm that all the information displayed are correct and I want to proceed further for Exam and Paper Selection</Label>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={confirmDetails} disabled={isDisabled} >
                  Confirm
                </Button>{' '}
                <Button color="secondary" onClick={Cancel}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </Col>
      </Row>
    </div>
    </div>
    </>
    
  );
};

export default Registration;
